module.exports = __webpack_public_path__ + "img/73ne.a3cb5e4e.svg";